export default {
  META: {
    TITLE: 'midtones.de - Kontakt'
  },
  HEADING: 'Nehmen Sie Kontakt auf',
  INTRO: 'Wenn Sie Interesse an einer Zusammenarbeit haben, dann nehmen Sie doch mit mir Kontakt auf. Bitte erwähnen Sie grob, um was es Ihnen geht und welcher Zeitraum Ihnen vorschwebt - sowohl Beginn als auch Ende (eventuell vorhandene Deadlines). Ich werde mich so schnell wie möglich mit Ihnen in Verbindung setzen.',
};
